// angular
// 	.module("HeroPRO")
// 	.directive('hpSpinnerButton', spinnerButton);

import './spinnerButton.scss';

export default function spinnerButton() {
    return {
        restrict: 'E',
        scope: {
            buttonFn: '&?',
            buttonName: '@',
            buttonId: '@?',
            buttonText: '@',
            displaySpinner: '=',
            isPrimaryBtn: '=',
            isSubmitButton: '=?',
            isDisabled: '=?',
        },
        templateUrl: 'app/common/controls/spinnerButton/spinnerButton.html',
        link(scope, element) {
            const button = element[0].querySelector('.btn');
            button.setAttribute('name', scope.buttonName);
            if (!scope.isSubmitButton) {
                button.setAttribute('type', 'button');
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/controls/spinnerButton/spinnerButtonDirective.js